import React from 'react';
import './icons.css';

const TONE_ALIASES = {
    critical: 'danger',
    error: 'danger',
    neutral: 'muted',
};

/**
 * Icon wrapper. Decorative by default (aria-hidden); pass `label` when the icon carries meaning.
 * size: xs | sm | md | lg | xl. tone: default (inherits text colour) | primary | muted | success |
 * warning | danger | info | inverse.
 */
export default function Icon({
    glyph,
    size = 'md',
    tone = 'default',
    label,
    className = '',
    ...rest
}) {
    const resolvedTone = TONE_ALIASES[tone] || tone;
    const classes = [
        'icon',
        size ? `icon--${size}` : '',
        resolvedTone !== 'default' ? `icon--${resolvedTone}` : '',
        className,
    ].filter(Boolean).join(' ');

    return (
        <span
            className={classes}
            role={label ? 'img' : undefined}
            aria-label={label || undefined}
            aria-hidden={label ? undefined : true}
            {...rest}
        >
            {glyph}
        </span>
    );
}
